export default {
  "Enter your email and password to sign in": "輸入電郵及密碼登入",
  "Sign In": "登入",
  "Login email": "登入電郵",
  English: "英文",
  "Traditional Chinese": "繁體中文",
  "Simplified Chinese": "簡體中文",
  "Search...": "搜尋...",
  new: "新增",
  Edit: "編輯",
  edit: "編輯",
  save: "儲存",
  Page: "網頁",
  Pages: "網頁",
  pages: "網頁",
  "New Page": "新增網頁",
  "Edit Page": "編輯網頁",
  All: "全部",
  Draft: "草稿",
  draft: "草稿",
  Scheduled: "已排期",
  Published: "已放佈",
  Suspended: "停止放佈",
  "Enter Content": "輸入內容",
  "Enter CSS": "輸入CSS",
  "Search Engine Optimization": "搜尋引擎優化 SEO",
  "Meta Title": "Meta 標題",
  "Enter Meta Title": "輸入 Meta 標題",
  "Meta Keywords": "Meta 關鍵字",
  "Enter Meta Keywords": "輸入 Meta 關鍵字",
  "Description": "描述",
  "Enter Description": "輸入描述",
  "Meta Description": "Meta 描述",
  "Enter Meta Description": "輸入 Meta 描述",
  "Page Settings": "網頁設置",
  "Last edit": "最後修改",
  "Push Notification": "推送",
  "Push Notification Setting": "推送設定",
  "Enable": "開啟",
  "Disable": "關閉",
  "Optional": "可選",
  Content: "內容",
  status: "狀態",
  STATUS: "狀態",
  Slug: "鏈結名稱",
  slug: "鏈結名稱",
  Title: "網頁名稱",
  title: "網頁名稱",
  "Published on": "發佈於",
  "Editted on": "編輯於",
  "Missing title": "必須輸入網頁名稱",
  "Missing slug": "必須輸入鏈結名稱",
  "posts": "貼文",
  "Posts": "貼文",
  "post types": "貼文類型",
  "Post Type": "貼文類型",
  "Post Types": "貼文類型",
  "Post Settings": "貼文設置",
  "New Post Type": "新增貼文類型",
  "Edit Post Type": "編輯貼文類型",
  "Post Type Name": "貼文類型名稱",
  "No. of Posts": "貼文數量",
  "Created On": "建立於",
  "Editted On": "編輯於",
  "Categories": "種類",
  "Sub-categories": "新手入門主題分類",
  "Beginner Guide": "新手入門",
  "Intermediate": "中級",
  "Advanced": "高級",
  "Gold Agent": "黃金代理",
  "Spot Trading of Gold": "現貨黃金",
  "Spot Trading of Silver": "現貨白銀",
  "London Gold": "倫敦金",
  "London Silver": "倫敦銀",
  "New Post": "新增貼文",
  "Edit Post": "編輯貼文",
  "Select a Thumbnail": "選擇縮圖",
  "Select": "選擇",
  "Thumbnail": "縮圖",
  "Upload": "上載",
  "Uploaded": "上載完成",
  "Failed": "失敗",
  "Library": "媒體庫",
  "IMAGE": "圖片",
  "FILE NAME": "檔案名稱",
  "黃金代理": "黃金代理",
  "現貨黃金": "現貨黃金",
  "現貨白銀": "現貨白銀",
  "倫敦銀": "倫敦銀",
  "倫敦金": "倫敦金",
  "新手入門": "新手入門",
  "中級": "中級",
  "高級": "高級",
  "News Notice": "消息公告",
  "System Notice": "系統公告",
  "Others Notice": "其他公告",
  "Sub-title": "副標題",
  "Marquee": "走馬燈文字",
  "Publish Settings": "發佈設置",
  "Schedule to Publish": "排期發佈",
  "Publish Now": "立即發佈",
  "Publish Date": "發佈日期",
  "Publish Time": "發佈時間",
  "Content Types": "內容類型",
  "Video Link": "影片連結",
  "External Link": "外部連結",
  "HTML Content": "HTML 內容",
  "Invalid date entered": "輸入的日期無效",
  "delete": "刪除",
  "Confirm to delete?": "確定刪除?",
  "Yes": "是",
  "No": "否",
  "Home Page": "首頁",


  "Name": "姓名",
  "Area Code": "區碼",
  "Mobile Number": "電話",
  "User Type": "用戶類別",
  "Status": "狀態",
  "All":"所有",
  "Active": "啟用",
  "Inactive":"停用",
  "active": "啟用",
  "inactive":"停用",
  "Users":"用戶",
  "ADD USER" : "新增用戶",
  "Live" : "真實帳戶",
  "Demo" : "模擬帳戶",
  "Portal User" : "普通帳戶",

  "Edit User": "編輯用戶",
  "New User": "新增用戶",
  "+86 China": "+86 中國",
  "+852 Hong Kong China": "+852 中國香港",
  "+853 Macau China": "+853 中國澳門",
  "+886 Taiwan China": "+886 中國台灣",
  "+60 Malaysia": "+60 馬來西亞",
  "+84 Vietnam": "+84 越南",
  "Name is required": "請輸入名稱",
  "Area Code is required": "請輸入區碼",
  "Mobile number is required": "請輸入電話號碼",
  "Mobile number is invalid": "請輸入正確電話號碼",
  "OA Client ID": "OA Client ID",
  "Price Reminder Expiry Date": "價格提示到期日",
  "Choose a status": "選擇狀態",
  "Status is required": "請選擇狀態",

  "Real Name": "真實姓名",
  "Gender": "性別",
  "Mobile": "手機號碼",
  "Email": "電子郵件",
  "Grade": "客戶身份",
  "ID Number": "證件號碼",
  "ID Type": "證件類型",
  "Address": "戶籍地址",
  "Agent Number": "代理號碼",
  "Referral Code": "推薦碼",
  "Subscribe State": "短訊訂閱狀態",
  "Club State": "漢聲薈註冊狀態",
  "Club Score": "漢聲薈會員積分",
  "Club Level": "漢聲薈會員等級",
  "Balance": "余額",
  "Equity": "凈值",
  "Margin": "保證金",
  "Male" : "男",
  "Female" : "女",
  "Normal Account" : "普通客戶",
  "Professional Account" : "專業投資者",
  "Registered" : "已註冊",
  "Not yet register" : "未註冊",
  "Subscribed": "已申请",
  "Not yet subscribe": "未申请",
  "China ID" : "中國",
  "Others" : "其他",
  "ID Front Image": "證件正面照",
  "ID Back Image": "證件背面照",
  "ID Hand Held Image": "手持證件照",
  "Bank Card Image": "銀行卡照片",
  "View Image": "顯示圖片",
  "Demo Account Information (Read Only)": "模擬帳戶資料 (唯讀)",
  "OA Information (Read Only)": "OA 帳戶資料 (唯讀)",
  "Bank Information (Read Only)": "銀行資料 (唯讀)",
  "Bank Name": "銀行名稱",
  "Bank User Name":"銀行賬戶姓名",
  "Bank Account": "銀行卡賬號",
  "Bank Branch": "支行地址",
  "Update": "更新",
  "Create": "新增",
  "Cancel":"取消",
  "History":"紀錄",
  "settings":"設置",
  "Settings":"設置",
  "Settings Updated":"設置更新成功",
  "Language":"語言",
  "Admin Users":"內部用戶",
  "Last Name": "姓氏",
  "First Name": "名稱",
  "Mobile Number": "手機號碼",
  "Login Email": "登入電郵",
  "Department": "部門",
  "Position": "職位",
  "LOGOUT": "登出",
  "Logout": "登出",
  "Incorrect password entered": "輸入密碼不正確",

  "Edit Admin User": "更新內部用戶",
  "New Admin User": "新增內部用戶",
  "IT": "電腦部",
  "Marketing": "市場部",
  "CS": "客戶服務部",
  "Admin": "管理員",
  "Manager": "經理",
  "Staff": "員工",
  "Your email address is invalid": "您的電郵輸入不正確",
  "Login email is required": "請輸入電郵",
  "Last name is required": "請輸入姓氏",
  "First name is required": "請輸入名稱",
  "Password": "密碼",
  "Confirm Password": "確認密碼",
  "Password is required": "請輸入密碼",
  "Password not match with confirm password": "密碼和確認密碼不相同",
  "Choose a Department": "選擇部門",
  "Choose a Position": "選擇職位",
  adminUsers: "內部用戶",
  users: "用戶",
  "Media Library": "媒體庫",
  "media library": "媒體庫",
  "COPY LINK": "複製連結",
  "ADD IMAGE": "新增圖片",
  "Upload": "上載",
  "upload": "上載",
  "Drop files here to upload": "將檔案拖曳到此處進行上傳",
  "IMAGE": "圖片",
  "FILE NAME": "檔案名稱",
  "REMARK": "備註",
  "COPY LINK": "複製連結",
  "BACK": "返回",
  "Image": "圖片",
  "Widget": "工具",
  "Edit Widget": "編輯工具",
  "widgets": "工具",
  "Widget Name": "工具名稱",
  "Banners": "橫幅",
  "Banner": "橫幅",
  "banners": "橫幅",
  "Homepage Banner": "首頁橫額",
  "New Banner": "新增橫幅",
  "Add Banner": "新增橫幅",
  "URL": "網址",
  "External Link?": "外部連結?",
  "External Link": "外部連結",
  "Internal Link": "內部連結",
  "Confirm": "確定",
  "Missing banner": "必須選擇橫幅",
  "Missing image": "必須選擇圖片",
  "Missing text": "必須輸入文字",
  "Missing URL": "必須輸入網址",
  "Popup": "彈出視窗",
  "Popups": "彈出視窗",
  "popups": "彈出視窗",
  "Homepage Popup": "首頁彈出視窗",
  "Add Popup": "新增彈出視窗",
  "New Popup": "新增彈出視窗",
  Text: "文字",
  "Display Date (yyyy-MM-dd)": "顯示日期 (yyyy-MM-dd)",
  "Image URL": "圖片連結",
};
